module.exports = __webpack_public_path__ + "static/media/Nathaniel Stuart.8b10869a.jpg";